import { $api } from '@service/RequestService';
import { FileTemplateLanguage } from '@utils/models/FileTemplate';
import { useMutation } from 'react-query';
import { ArrayParam, NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { endPoints } from '../utils/constants/endPoint';

export function useDownloadFormFacebookToExcel() {
  const [allQueries] = useQueryParams({
    search: StringParam,
    page: NumberParam,
    size: NumberParam,
    status: StringParam,
    forms: ArrayParam,
    startDate: StringParam,
    finishDate: StringParam,
    startDateFacebook: StringParam,
    finishDateFacebook: StringParam
  });

  return useMutation(async (lang: FileTemplateLanguage | undefined) => {
    const body = {
      search: allQueries?.search || undefined,
      page: allQueries?.page || 1,
      size: allQueries?.size || 10,
      status: allQueries?.status || undefined,
      forms: allQueries?.forms || undefined,
      startDate: allQueries?.startDate || undefined,
      finishDate: allQueries?.finishDate || undefined,
      startDateFacebook: allQueries?.startDateFacebook || undefined,
      finishDateFacebook: allQueries?.finishDateFacebook || undefined
    };

    const res = await $api.post(`${endPoints.FORM_LEAD_FILTER_EXCEL}?lang=${lang}`, body);

    return res?.data?.data;
  });
}
